module.exports = __webpack_public_path__ + "static/media/default.61fac72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/spare/index/default.png
// module id = 1210
// module chunks = 0